import React from "react";

export function VideoLayout(props) {
  return (
    <div>
      <div>{props.children}</div>
    </div>
  );
}
